<nav class="navbar navbar-dark dash-nav navbar-expand-lg text-white">
  <a class="navbar-brand" [routerLink]="['/dashboard']">
    <img src="./assets/img/logo-wht.svg" style="height: 3rem; width:16.5625rem;" alt="Central Bank of The Bahamas" />
  </a>
  <div class="collapse navbar-collapse justify-content-end">
    <ul class="navbar-nav">
      <li class="nav-item nav-mat-item mat-route">
        <button mat-button [routerLink]="['/dashboard/account']" routerLinkActive="active">
          Account
        </button>
      </li>
      <li class="nav-item nav-mat-item mat-route">
        <button mat-button [routerLink]="['/dashboard/application']" routerLinkActive="active">
          Application
        </button>
      </li>
      <li class="nav-item nav-mat-item mat-route">
        <button mat-button [routerLink]="['/dashboard/view']" routerLinkActive="active">
          View
        </button>
      </li>


      <li class="nav-item nav-mat-icon-item">
        <button mat-icon-button [matMenuTriggerFor]="accountMenu" matTooltip="Account Options">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu">
          <button mat-menu-item [routerLink]="['/dashboard/changePassword']" routerLinkActive="active">
            Modify Password
          </button>

          <button mat-menu-item [routerLink]="['/dashboard/Unsubcribe']" routerLinkActive="active">
            Unsubcribe
          </button>
          
          <button mat-menu-item (click)="_authService.logout()">
            Log Out
          </button>

        </mat-menu>
      </li>
    </ul>
  </div>
  <li id="navicon">
    <button mat-icon-button class="navicon-close" (click)="dropdownOpen=!dropdownOpen">
      <mat-icon>add</mat-icon>
    </button>
  </li>
</nav>
<div [class.nav-slide-in]="dropdownOpen" [class.nav-slide-out]="!dropdownOpen" id="navdrop">
  <span class="navdrop-backdrop" (click)="dropdownOpen=!dropdownOpen">
  </span>
  <button mat-icon-button class="navicon-close" (click)="dropdownOpen=!dropdownOpen">
    <mat-icon>close</mat-icon>
  </button>
  <div class="navdrop-menu" [class.active]="dropdownOpen" [class.inactive]="!dropdownOpen">
    <ul [class.fadeItemsIn]="dropdownOpen">

      <li class="nav-item">
        <a class="button" (click)="dropdownOpen=!dropdownOpen" [routerLink]="['/dashboard/account']"
          routerLinkActive="active"> Account </a>
      </li>
      <li class="nav-item">
        <a class="button" (click)="dropdownOpen=!dropdownOpen" [routerLink]="['/dashboard/application']"
          routerLinkActive="active"> Application </a>
      </li>

      <li class="nav-item">
        <a class="button" (click)="dropdownOpen=!dropdownOpen" [routerLink]="['/dashboard/view']"
          routerLinkActive="active"> View</a>
      </li>
      <li>
        <a class="button" (click)="dropdownOpen=!dropdownOpen" [routerLink]="['/dashboard/changePassword']"
          routerLinkActive="active">Modify Password</a>
      </li>

      <li>
        <a class="button" (click)="dropdownOpen=!dropdownOpen" [routerLink]="['/dashboard/Unsubcribe']"
          routerLinkActive="active">Unsubcribe</a>
      </li>


      <li class="nav-item">
        <a class="nav-link button" (click)="_authService.logout()" (click)="dropdownOpen=!dropdownOpen"> Log Out</a>
      </li>
    </ul>
  </div>
</div>
<div class="body-container">
  <router-outlet></router-outlet>
</div>
<footer class="footer bg-dark text-white">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <i class="fa fa-copyright" aria-hidden="true"></i>
        <span>Central Bank of The Bahamas</span>
        <span> {{currentYear}} </span>
        <span class="text-muted">&nbsp;&nbsp;&nbsp; Site built by QTZL
          <sup>&reg;</sup> a division of
          <a href="https://www.mimics.com">MIMICS
            <sup>&reg;</sup>
          </a>
        </span>
      </div>
    </div>
  </div>
</footer>